import * as React from "react";
import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { SecurityAppSecurityEvents } from "@graylog/enterprise-api";
import SuggestionsList from "components/common/EntityFilters/FilterConfiguration/SuggestionsList";
import useCurrentUser from "hooks/useCurrentUser";
import { useGetUsersNTeams } from "security-app/hooks/useSecurityEventsAPI";
import { adminAssignee } from "security-app/components/SecurityEvents/Alerts/hooks/useOwnerTitles";
const DEFAULT_SEARCH_PARAMS = {
  query: "",
  pageSize: 10,
  page: 1
};
const fetchAssignedOwnerIds = () => SecurityAppSecurityEvents.getFilterOptions({
  fields: ["owner"],
  timerange: 30 * 86400
}).then((resp) => {
  var _a;
  return (_a = resp.owner) != null ? _a : [];
});
const OwnerFilter = ({ attribute, allActiveFilters, filter, filterValueRenderer, onSubmit }) => {
  const [filterQuery, setSearchParams] = useState(DEFAULT_SEARCH_PARAMS);
  const { data: assignedOwnerIds, isInitialLoading } = useQuery({
    queryKey: ["security_events", "owners"],
    queryFn: fetchAssignedOwnerIds
  });
  const { usersNTeams } = useGetUsersNTeams();
  const currentUser = useCurrentUser();
  const suggestions = useMemo(
    () => {
      if (!assignedOwnerIds) return void 0;
      const resolved = assignedOwnerIds.map((ownerId) => {
        const admin = adminAssignee(ownerId);
        if (admin) return { id: admin.id, value: admin.label };
        const match = usersNTeams.find((entry) => entry.id === ownerId);
        if (match) return { id: match.id, value: match.name };
        if (ownerId === currentUser.id) return { id: currentUser.id, value: currentUser.fullName };
        return void 0;
      }).filter(Boolean);
      return [
        { id: null, value: "no owner" },
        { id: currentUser.id, value: `Me (${currentUser.fullName})` },
        ...resolved.filter((suggestion) => suggestion.id !== currentUser.id)
      ].filter((suggestion) => suggestion.value.toLowerCase().includes(filterQuery.query.toLowerCase()));
    },
    [currentUser, assignedOwnerIds, usersNTeams, filterQuery]
  );
  return /* @__PURE__ */ React.createElement(
    SuggestionsList,
    {
      allActiveFilters,
      attribute,
      multiSelect: !filter,
      filterValueRenderer,
      onSubmit,
      suggestions,
      isLoading: isInitialLoading,
      total: suggestions == null ? void 0 : suggestions.length,
      page: 1,
      pageSize: suggestions == null ? void 0 : suggestions.length,
      setSearchParams
    }
  );
};
export default OwnerFilter;
